import { HeaderProps } from "@/src/layout/header/desktop/v1";
import { menuItemsProps } from "../menu";

export const headerData_en: HeaderProps = {
  menuItems: menuItemsProps,
  contactInfo: {
    title: "Need help?",
    phone: "(+964)785-010-0005",
  },
};
